/**
 * 官网目标码 → 中文(附录 A.15,三仓同码):api 把码存进 `xb_site.business_goal` / `secondaryGoals`,
 * 采集页目标题的选项值也是这套码。展示 `SiteDetail.businessGoal` 一类时用这张表,不各处手写。
 * ★ 未知码原样显示(与 schemaLabels 同一条规矩):新目标先上 api,卡上出英文码也比消失强。
 */
export const GOAL_LABEL = {
  leads: "获取销售线索",
  product_promo: "产品推广",
  strength: "企业实力展示",
  quote: "获取报价",
  demo: "预约演示",
  phone: "电话咨询",
  wechat: "微信咨询",
  franchise: "招商加盟",
} as const satisfies Record<string, string>;

export type GoalCode = keyof typeof GOAL_LABEL;

export function isGoalCode(code: string): code is GoalCode {
  return Object.prototype.hasOwnProperty.call(GOAL_LABEL, code);
}

/** 码 → 中文;空 → null(调用方整段不画);未知码原样。 */
export function goalLabel(code: string | null | undefined): string | null {
  if (!code) return null;
  return isGoalCode(code) ? GOAL_LABEL[code] : code;
}
